virtual function void set_object(TYPE object);
  this.object = object;
endfunction
